module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "PersonOrArtifactModal"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "",
      "large": "",
      "force": ""
    },
    on: {
      "ok": function($event) {
        return _vm.ok()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.legalCaseId) ? _c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    class: _vm.personTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.pTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('pTab')
      }
    }
  }, [_vm._v("Person")])]), _vm._v(" "), _c('li', {
    class: _vm.artifactTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.aTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('aTab')
      }
    }
  }, [_vm._v("Object")])]), _vm._v(" "), _c('li', {
    class: _vm.urlTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.uTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('uTab')
      }
    }
  }, [_vm._v("URL")])])])]) : _c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    class: _vm.artifactTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.aTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('aTab')
      }
    }
  }, [_vm._v("Object")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content ul-top-buffer"
  }, [(_vm.legalCaseId) ? _c('div', {
    class: _vm.personTabClass,
    attrs: {
      "id": _vm.pTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('SearchPersonOrganisation', {
    key: _vm.updateSearchPersonOrganisationBindId,
    ref: "search_person_organisation",
    attrs: {
      "personOnly": "",
      "excludeStaff": true,
      "isEditable": !_vm.readonlyForm,
      "classNames": "form-control",
      "showCreateUpdate": "",
      "addFullName": "",
      "displayTitle": false,
      "entityEdit": _vm.entityEdit
    },
    on: {
      "entity-selected": _vm.entitySelected
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.artifactTabClass,
    attrs: {
      "id": _vm.aTab
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.componentType),
      expression: "componentType"
    }],
    attrs: {
      "type": "radio",
      "id": "document",
      "value": "document"
    },
    domProps: {
      "checked": _vm._q(_vm.componentType, "document")
    },
    on: {
      "change": function($event) {
        _vm.componentType = "document"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "document"
    }
  }, [_vm._v("Document")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.componentType),
      expression: "componentType"
    }],
    attrs: {
      "type": "radio",
      "id": "physical",
      "value": "physical"
    },
    domProps: {
      "checked": _vm._q(_vm.componentType, "physical")
    },
    on: {
      "change": function($event) {
        _vm.componentType = "physical"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "physical"
    }
  }, [_vm._v("Physical Object")])])]), _vm._v(" "), (_vm.showDocumentArtifactComponent) ? _c('div', [_c('DocumentArtifact', {
    key: _vm.updateDocumentArtifactBindId,
    ref: "document_artifact",
    attrs: {
      "parentModal": "",
      "entityEdit": _vm.entityEdit
    },
    on: {
      "entity-selected": _vm.entitySelected,
      "existing-entity-selected": _vm.existingEntitySelected,
      "error-message": _vm.setDocumentArtifactErrorMessage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showPhysicalArtifactComponent) ? _c('div', [_c('PhysicalArtifact', {
    key: _vm.updatePhysicalArtifactBindId,
    ref: "physical_artifact",
    attrs: {
      "parentModal": "",
      "entityEdit": _vm.entityEdit
    },
    on: {
      "entity-selected": _vm.entitySelected,
      "existing-entity-selected": _vm.existingEntitySelected
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.legalCaseId) ? _c('div', {
    class: _vm.urlTabClass,
    attrs: {
      "id": _vm.uTab
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.urlProtocol),
      expression: "urlProtocol"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "protocol"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.urlProtocol = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "https"
    }
  }, [_vm._v("https")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "http"
    }
  }, [_vm._v("http")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.urlText),
      expression: "urlText"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputUrl",
      "type": "text"
    },
    domProps: {
      "value": (_vm.urlText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.urlText = $event.target.value
      }
    }
  })])])]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29e6b9f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/person_or_artifact_modal.vue
// module id = 942
// module chunks = 0